//OtkritieRegistratsiiNaZasedaniePravleniyaFederatsii
import React, {  } from 'react';
import { useSelector } from 'react-redux';
import { DatePicker, Form, Input } from 'antd';


import locale from 'antd/es/date-picker/locale/ru_RU';

import REDUX_ZasedaniyaPravleniyaFederatsii from '../../../objects/ZasedaniyaPravleniyaFederatsii/reducer'


export default function OtkritieRegistratsiiNaZasedaniePravleniyaFederatsii(props) {

	const {zasedanie} = props;

    // const [city, setCity] = useState([]);

    // useEffect(() => {
    //     auth.fetch('/api/query/City?s-name').then(res => {
    //         if (res && res.data) {
    //             setCity(res.data);
    //         }
    //     });
    // }, []);

    // const options = city.map(i => (
    //     <Option key={i.ID} value={i.ID}>{i.name}</Option>
    // ));
    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
            initialValues={{
                neobkhodimiiKvorum: 50,
                zasedaniePravleniyaFederatsiiID: zasedanie.ID 
            }}
        >
            <Form.Item
                preserve={"true"}
                hidden={true}
                name={"zasedaniePravleniyaFederatsiiID"}
                label={"Заседание правления федерации"}
                rules={[{ required: true, message: 'Укажите заседание правления федерации!' }]}
            >
                <Input disabled />
            </Form.Item>

            <Form.Item
                name={"dataNachalaRegistratsiiUchastnikov"}
                label={"Дата начала регистрации участников"}
                rules={[{ required: true, message: 'Укажите дату начала регистрации участников!' }]}
            >
                <DatePicker locale={locale} />
            </Form.Item>
        </Form>
    );
}
